export default {
  notifications: []
}



// WEBPACK FOOTER //
// ./~/vue-components/notifications/store/state.js